/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/58400608
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import * as CertificateCard from '@components/LibraryProgramsCertification';
import AppActions from '~/actions/app';
import DevelopActions from '~/actions/develop';
import withNavigate from '~/hocs/withNavigate';

class CertificationEdit extends Component {
    constructor(props) {
        super(props);

        const userId = Number(props.params?.userId || 0);
        const certId = Number(props.params?.id || 0);

        const { templates } = props;
        const program = find(propEq('id', certId), templates.certifications.data);

        this.state = { program };
    }

    handleSelect = () => {};

    render() {
        const { authors, departments, competencies, categories, companyId, companies, userRole } = this.props;
        const tags = { authors, departments, competencies, categories };
        const { program } = this.state;
        const company = find(propEq('id', companyId), companies);
        const jobRoles = company.job_roles;

        return (
            <ErrorBoundary>
                <Filter back="Back" />
                <CertificateCard.Edit
                    tags={tags}
                    program={program}
                    jobs={jobRoles}
                    role={userRole}
                    onModal={(e) => this.props.toggleModal(e)}
                    onSave={(e) => this.props.saveProgram(e)}
                    onSelect={this.handleSelect}
                />
            </ErrorBoundary>
        );
    }
}

CertificationEdit.propTypes = {
    authors: PropTypes.array,
    categories: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    saveProgram: PropTypes.func,
    toggleModal: PropTypes.func,
};

CertificationEdit.defaultProps = {
    authors: [],
    categories: [],
    departments: [],
    competencies: [],
    saveProgram: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    userRole: state.app.app_role_id,
    companyId: state.app.company_info.id,
    templates: state.develop.templates,
    authors: state.app.authors,
    categories: state.app.categories,
    departments: state.app.departments,
    competencies: state.app.competencies,
    companies: state.app.companies,
});

const mapDispatchToProps = (dispatch) => ({
    saveProgram: (e) => dispatch(DevelopActions.librarysaveRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const CertificationEditWithNavigate = withNavigate(connect(mapStateToProps, mapDispatchToProps)(CertificationEdit));
export default CertificationEditWithNavigate;
